<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>Email</translate></label>
        <v-text-field
          class="field-custom mt-1 mb-3"
          v-model="formData.email"
          :rules="emptyRules"
          outlined
          required
          disabled
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="4" class="py-0 d-flex align-center" v-if="!showPass">
        <v-btn
          text
          color="blue"
          class="text-none subtitle-1 px-0 pt-md-5"
          @click="showPass = !showPass"
        >
          <translate>Change your password</translate>
        </v-btn>
      </v-col>
      <v-col cols="12" :md="4" class="py-0" v-if="showPass">
        <label class="titleForm"><translate>Current Password</translate></label>
        <v-text-field
          class="field-custom mt-1 mb-3"
          v-model="formData.currentPassword"
          :rules="emptyRules"
          :type="showInput1 ? 'text' : 'password'"
          :append-icon="showInput1 ? 'fal fa-eye' : 'fal fa-eye-slash'"
          @click:append="showInput1 = !showInput1"
          outlined
          required
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="4" class="py-0" v-if="showPass">
        <label class="titleForm"><translate>New password</translate></label>
        <v-text-field
          class="field-custom mt-1 mb-3"
          v-model="formData.newPassword"
          :rules="emptyRules"
          :type="showInput2 ? 'text' : 'password'"
          :append-icon="showInput2 ? 'fal fa-eye' : 'fal fa-eye-slash'"
          @click:append="showInput2 = !showInput2"
          outlined
          required
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="12" class="mb-4" v-if="!hideSubmit">
        <v-btn
          large
          @click="$emit('cancel')"
          class="font-weight-bold elevation-0 text-none subtitle-1 mr-3"
        >
          <translate>Cancel</translate>
        </v-btn>
        <v-btn
          large
          type="submit"
          color="primary"
          @click.prevent="onSubmit"
          class="font-weight-bold elevation-0 text-none subtitle-1"
        >
          <translate>Save</translate>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import Vue from 'vue';
export default {
  props: ["email", "hideSubmit"],
  data() {
    return {
      showPass: false,
      valid: true,
      emptyRules: [(v) => !!v || Vue.prototype.$gettext("Field is required")],
      emailRules: [
        (v) => !!v || Vue.prototype.$gettext("E-mail is required"),
        (v) => /.+@.+\..+/.test(v) || Vue.prototype.$gettext("E-mail must be valid"),
      ],
      showInput1: false,
      showInput2: false
    };
  },
  computed: {
    formData() {
      let data = {
        email: this.email || "",
        currentPassword: "",
        newPassword: "",
      };
      return data;
    },
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("submit", { type: "account", data: this.formData });
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>